// extracted by mini-css-extract-plugin
module.exports = {"main_title":"Kafedra_main_title__AXwOw","person":"Kafedra_person__3zRvR","photo":"Kafedra_photo__umzVK","text":"Kafedra_text__2Nk_X","name":"Kafedra_name__34qS8"};